<template>
  <q-page padding>
    <section class="container q-py-xl">
      <div class="row q-mt-xl">
        <auth-form
          class="q-mx-auto"
          hide-social-login
        >
          <registration
            :redirect-route-url="`/${this.$i18n.locale}/carrier/`"
          />
        </auth-form>
        <div>
          <h2 class="title text-center">{{ content.header }}</h2>
          <div class="row justify-between q-mt-xl q-px-md">
            <div
              v-for="(item, index) in content.items"
              :key="index"
              class="col-12 col-md-3 text-center"
            >
              <img
                :src="`img/carrier/carrier-${index}.svg`"
                alt=""
              >
              <h3 class="text-uppercase">{{ item.title }}</h3>
              <p class="fs-14">{{ item.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </q-page>
</template>

<script>
import AuthForm from 'components/AuthForm';

import Registration from '~components/Registration';

export default {
  name: 'NewCarrier',
  components: {
    AuthForm,
    Registration,
  },
  preFetch({
    store, redirect, currentRoute, urlPath, ssrContext,
  }) {
    const { account, configs } = store.getters;

    if (ssrContext.themeName) {
      redirect(`${configs.base_url}${urlPath}`);
    } else if (account?.email && account.phone) {
      redirect(`/${currentRoute.params.locale}/carrier/`);
    }
  },
  computed: {
    content() {
      return this.$t('pages.become_a_carrier');
    },
  },
  mounted() {
    window.afterAnalyticsInit = () => {
      try {
        window.gtag('event', 'newdriver 1/2', { event_action: 'newdriver1' });
      } catch (e) {}
      try {
        window.gtYaCounter('reachGoal', 'addnewcarrier');
      } catch (e) {}
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 28px;
  margin-top: 40px;
}

h3 {
  font-size: 1.1em;
  line-height: 1.4em;
  margin: 0 auto 1.4em;
  width: 200px;
}
</style>
